export const FeatureFlagWrapper = {
    bindings: {
        flag: '@'
    },
    transclude: {
        flagOn: '?flagOn',
        flagOff: '?flagOff'
    },
    template: `
        <div ng-transclude="flagOn" ng-if="$ctrl.featureEnabled()"></div>
        <div ng-transclude="flagOff" ng-if="!$ctrl.featureEnabled()"></div>
    `,
    controller: class{
        constructor(featureFlagService) {
            'ngInject';
            this.flags = featureFlagService.data;
        }

        featureEnabled() {
            let featureToCheck = this.flag;
            return this.flags.features.has(featureToCheck);
        }
    }
};
